import { RootState } from "../../rootReducer";

export const selectIsLoadingUserListBusiness = (state: RootState) =>
  state.userListBusiness.loading;
export const selectUserListBusinessErrorMessage = (state: RootState) =>
  state.userListBusiness.error;
export const userListBusinessResponse = (state: RootState) =>
  state.userListBusiness.userListBusinessResponse;
